import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import SubCategories from '@/components/v2/inquiry/SubCategories';
import ActionButton from '@/components/action_button/Index.vue';
let SubCategoriesListView = class SubCategoriesListView extends Vue {
    get headers() {
        return [
            {
                text: 'Category Name',
                value: 'category',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Description',
                value: 'description',
                align: 'left',
                sortable: false,
            },
        ];
    }
};
__decorate([
    Prop({ type: String, required: true })
], SubCategoriesListView.prototype, "categoryUuid", void 0);
SubCategoriesListView = __decorate([
    Component({
        components: {
            SubCategories,
            ActionButton,
        },
    })
], SubCategoriesListView);
export default SubCategoriesListView;
